module.exports = __webpack_public_path__ + "res/img/share.f81fc948.png";